/* eslint-disable import/prefer-default-export */
export const UPLOAD_ORIGINS = {
  PATIENT_PORTAL: 'patientPortal',
};
